/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo, MouseEventHandler} from 'react';
import {MenuItem} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {dlsColor, dlsTypography} from '../../theme/theme';
import {BodyTypography} from '../../typography/BodyTypography';

export interface MenuOptionProps {
  onClick: MouseEventHandler;
  label: string;
}

const useStyles = makeStyles(() => ({
  menuItem : {
    padding   : '12px 22px !important',
    width     : 256,
    '&:hover' : {
      backgroundColor : dlsColor('paleBlue')
    }
  },
  label : {
    ...dlsTypography('body2'),
    fontSize : '16px'
  }
}));

/**
 * Generic menu option for re-use.
 * 
 * ```typescript
 * 
 *  import {MenuOption} from '@ion/dls/src/components/menus';
 * 
 *  <MenuOption label={'Click Me!'}
 *    onClick={onClick} />
 * 
 * ```
 */
export const MenuOption = ({
  onClick,
  label
}: MenuOptionProps) => {
  const classes = useStyles();
  return (
    <MenuItem onClick={onClick}
      classes={{
        root : classes.menuItem
      }}>
      <BodyTypography className={classes.label}>
        {label}
      </BodyTypography>
    </MenuItem>
  );
};

export default memo(MenuOption);
